// hooks/useSelectUser.js
import { useQuery } from "@tanstack/react-query";
import usersAPI from "features/Setting/users/api/userApis";
import apiClient from "lib/api-client";
import { getUserDetail } from "utils/getUserDetailsHelper";

export const useSelectUser = () =>
  useQuery({
    queryKey: ["LabourChartsUsers"],
    queryFn: usersAPI.getAllUserData,
    cacheTime: 200000,
    staleTime: 20000,
    refetchOnWindowFocus: true,
  });

// ------------------------------  Update Rate Master ----------------------------- //

export const updateLabourChart = async (payload) => {
  let response = await apiClient.post(`/api/v1/rateMaster/labour`, payload);
  return response.data;
};

// ------------------------------  Get Rate Master ----------------------------- //

export const getSpecificLaborChart = async (User) => {
  let response = await apiClient.get(`/api/v1/rateMaster/labour?userId=${User}`);
  return response.data;
};

export const getlabourChartData = async () => {
  try {
  let response = await apiClient.get(`/api/v1/rateMaster/getLabourData`);
  return response.data.data;
  } catch (error) {
    console.log("There was a error",error)
  }
};

export const useLabourChartData = () => {
  return useQuery({
    queryKey: ["LabourChartData"],
    queryFn: getlabourChartData,
    staleTime: 12000,
  });
};